import React from "react";
import NavigationSidebar from "../NavigationSidebar/index.js";
import ExploreComponent from "./ExploreComponent.js";
import Whos from "../Whos";


const ExploreScreenA9 = () => {
  return(
      <div className="container ">
          <div className="row mt-2 gx-0">
            <div className="col-sm-2 col-md-2 col-lg-1 col-xl-2 col-xxl-2">
              <NavigationSidebar active={"explore"}/>
            </div >
            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
              <ExploreComponent/>
            </div>
            <div className="col-sm-0 col-md-0 col-lg-4 col-xl-4 col-xxl-4 d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block">
              <Whos/>
            </div>
          </div>
        </div>
    );
};
export default ExploreScreenA9;

